<mat-slide-toggle
  (change)="onChange($event)"
  [checked]="isOn"
  [disabled]="isDisabled"
>
  <ng-content></ng-content>
</mat-slide-toggle>
